export function isCategoryPage(data) {
  return data?.type === 'Category' && !data?.dataJson?.category?.isLocked
    ? true
    : false;
}

export function isProductPage(data) {
  return data?.type === 'Product' && data?.dataJson?.product ? true : false;
}
